/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { FunctionComponent } from 'react';

import { IEmptyTileProps } from './ContentTile.props';

import './ContentTile.scss';

const EmptyTile: FunctionComponent<IEmptyTileProps> = ({ isEmpty }) => {
    return (
        <div className="content-tile-container empty-tile">
            {isEmpty && <div className="empty-content"></div>}
        </div>
    );
};

export default EmptyTile;
